import { useReferralInvites } from '@/components/layouts/ReferralInviteLayout/hooks/useReferralInvites'

export function useHasMultipleReferralInvites() {
  const invites = useReferralInvites()

  return invites['hydra:totalItems'] > 1
}
